import { Kind } from "graphql";
export function extractVariableNamesFromArguments(args) {
    if (!args) {
        return [];
    }
    const variableNames = [];
    args.forEach((argument)=>{
        if (argument.value.kind === Kind.VARIABLE) {
            variableNames.push(argument.value.name.value);
        }
    });
    return variableNames;
}
export function extractVariableNamesFromTopLevelField(field) {
    const variableNames = [];
    // Extract variables used as arguments to top level field
    variableNames.push(...extractVariableNamesFromArguments(field.arguments));
    // Extract variables used in directive on to top level field
    if (field.directives) {
        field.directives.forEach((directive)=>{
            variableNames.push(...extractVariableNamesFromArguments(directive.arguments));
        });
    }
    return variableNames;
}
export function extractFragmentNamesFromSelectionSet(selectionSet) {
    const fragmentNames = new Set();
    function extractFragments(selectionSet) {
        for (const selection of selectionSet.selections){
            if (selection.kind === Kind.FRAGMENT_SPREAD) {
                fragmentNames.add(selection.name.value);
            } else if (selection.kind === Kind.FIELD && selection.selectionSet) {
                extractFragments(selection.selectionSet);
            } else if (selection.kind === Kind.INLINE_FRAGMENT && selection.selectionSet) {
                extractFragments(selection.selectionSet);
            }
        }
    }
    extractFragments(selectionSet);
    return Array.from(fragmentNames);
}

//# sourceMappingURL=field.js.map